import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// O react-router não rola a página pro topo ao trocar de rota (só o browser
// faz isso em navegação normal) — sem isso, ir de uma solução pra outra
// mantém o scroll na posição da página anterior.
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
